module.exports = __webpack_public_path__ + "static/media/Twitter.eccaae4c.svg";